//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gameSound from '@/utils/gameSound'

/** 关卡难度：配对数随关卡递增，最多 8 组 */
function getLevelPairs (level) {
  return Math.min(3 + level, 8)
}

function getGridCols (pairs) {
  return pairs <= 6 ? 3 : 4
}

function shuffle (arr) {
  const a = arr.slice()
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const t = a[i]
    a[i] = a[j]
    a[j] = t
  }
  return a
}

function shortMean (mean) {
  if (!mean) return '—'
  const text = String(mean).replace(/<[^>]+>/g, '').trim()
  const first = text.split(/[；;，,]/)[0] || text
  return first.length > 28 ? first.slice(0, 28) + '…' : first
}

export default {
  name: 'WordMatch',
  data () {
    return {
      loading: true,
      wordBank: [],
      bankIndex: 0,
      level: 1,
      maxLevelReached: 0,
      cards: [],
      currentLevelPairs: 0,
      selected: [],
      matchedInLevel: 0,
      levelMistakes: 0,
      levelStartTime: 0,
      levelComplete: false,
      levelStars: 0,
      totalStars: 0,
      totalMatched: 0,
      combo: 0,
      maxCombo: 0,
      showSummary: false,
      elapsedTime: 0,
      timer: null,
      wrongPair: [],
      checking: false,
      soundEnabled: gameSound.isEnabled()
    }
  },
  computed: {
    scopeLabel () {
      if (this.$route.query.scope === 'book') return '全书消消乐'
      if (this.$route.query.unitCn) return this.$route.query.unitCn
      return '单词消消乐'
    },
    levelPairs () {
      return getLevelPairs(this.level)
    },
    nextLevelPairs () {
      return getLevelPairs(this.level + 1)
    },
    gridCols () {
      return getGridCols(this.levelPairs)
    },
    levelProgress () {
      const total = this.currentLevelPairs || this.levelPairs
      if (!total) return 0
      return Math.round((this.matchedInLevel / total) * 100)
    },
    formattedTime () {
      const m = Math.floor(this.elapsedTime / 60)
      const s = this.elapsedTime % 60
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
    levelTime () {
      return Math.max(0, this.elapsedTime - this.levelStartTime)
    },
    hasNextLevel () {
      return this.bankIndex < this.wordBank.length
    }
  },
  created () {
    this.$store.state.isShowBarKey = false
    this.loadWords()
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    loadWords () {
      const cellId = this.$route.query.cellId
      const scope = this.$route.query.scope
      this.loading = true
      if (cellId) {
        this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: cellId })
          .then(list => this.initBank(this.applyTrialWordCap(list || [])))
          .finally(() => { this.loading = false })
      } else if (scope === 'book') {
        this.$ajax.post(this.$api.getUnitListByBookId, { planId: this.$route.query.value })
          .then(units => {
            const unitList = units || []
            if (!unitList.length) return []
            const limited = unitList.some(u => u.isWordPower === 0 || u.isWordPower === '0')
              || this.$route.query.isWordPower === 0
              || this.$route.query.isWordPower === '0'
            // 未开通：只取首单元前 5 词，避免多单元各截 5 词绕过限制
            if (limited) {
              return this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: unitList[0].id })
                .then(w => this.applyTrialWordCap(w || []))
                .catch(() => [])
            }
            return Promise.all(
              unitList.map(u =>
                this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: u.id })
                  .then(w => w || []).catch(() => [])
              )
            ).then(results => {
              const merged = []
              const seen = new Set()
              results.flat().forEach(w => {
                const key = w.wordId || w.id
                if (!w || !key || seen.has(key)) return
                seen.add(key)
                merged.push(w)
              })
              return merged
            })
          })
          .then(list => this.initBank(list || []))
          .catch(() => this.initBank([]))
          .finally(() => { this.loading = false })
      } else {
        this.loading = false
      }
    },
    applyTrialWordCap (list) {
      const power = this.$route.query.isWordPower
      const limited = power === 0 || power === '0'
      if (limited && list.length > 5) {
        // keep in sync with trialAccess.TRIAL_WORD_LIMIT (=5)
        return list.slice(0, 5)
      }
      return list
    },
    initBank (list) {
      const bank = list
        .filter(w => (w.english || w.wordName) && w.mean)
        .map(w => ({
          id: String(w.wordId || w.id),
          english: (w.english || w.wordName || '').trim(),
          mean: shortMean(w.mean)
        }))
      this.wordBank = shuffle(bank)
      this.bankIndex = 0
      if (this.wordBank.length >= 3) {
        this.startLevel()
        this.startTimer()
      }
    },
    startLevel () {
      this.levelComplete = false
      this.matchedInLevel = 0
      this.levelMistakes = 0
      this.levelStartTime = this.elapsedTime
      this.selected = []
      this.wrongPair = []
      this.checking = false

      const pairs = this.levelPairs
      const slice = this.wordBank.slice(this.bankIndex, this.bankIndex + pairs)
      if (slice.length < 3) {
        this.finishGame()
        return
      }
      const actualPairs = slice.length
      this.currentLevelPairs = actualPairs
      this.bankIndex += actualPairs

      const cardList = []
      slice.forEach((word, i) => {
        cardList.push({
          uid: `en-${word.id}-${i}`,
          wordId: word.id,
          lang: 'en',
          text: word.english
        })
        cardList.push({
          uid: `zh-${word.id}-${i}`,
          wordId: word.id,
          lang: 'zh',
          text: word.mean
        })
      })
      this.cards = shuffle(cardList).map(c => ({ ...c, matched: false }))
    },
    cardClass (card) {
      return {
        'match-card--selected': this.selected.includes(card.uid),
        'match-card--matched': card.matched,
        'match-card--wrong': this.wrongPair.includes(card.uid),
        'match-card--en': card.lang === 'en',
        'match-card--zh': card.lang === 'zh'
      }
    },
    onCardTap (card) {
      if (this.levelComplete || card.matched || this.checking) return
      if (this.selected.includes(card.uid)) {
        this.selected = this.selected.filter(id => id !== card.uid)
        return
      }
      if (this.selected.length === 0) {
        this.selected = [card.uid]
        return
      }
      if (this.selected.length === 1) {
        const first = this.cards.find(c => c.uid === this.selected[0])
        if (!first) {
          this.selected = [card.uid]
          return
        }
        this.checking = true
        if (first.wordId === card.wordId && first.lang !== card.lang) {
          this.onMatch(first, card)
        } else {
          this.onMismatch(first, card)
        }
      }
    },
    onMatch (a, b) {
      a.matched = true
      b.matched = true
      gameSound.playCorrect()
      this.matchedInLevel++
      this.totalMatched++
      this.combo++
      if (this.combo > this.maxCombo) this.maxCombo = this.combo
      this.selected = []
      this.checking = false

      if (this.matchedInLevel >= this.cards.length / 2) {
        this.onLevelDone()
      }
    },
    onMismatch (a, b) {
      this.levelMistakes++
      this.combo = 0
      gameSound.playWrong()
      this.wrongPair = [a.uid, b.uid]
      this.selected = []
      setTimeout(() => {
        this.wrongPair = []
        this.checking = false
      }, 700)
    },
    onLevelDone () {
      if (this.levelMistakes === 0) this.levelStars = 3
      else if (this.levelMistakes <= 2) this.levelStars = 2
      else this.levelStars = 1
      this.totalStars += this.levelStars
      if (this.level > this.maxLevelReached) this.maxLevelReached = this.level
      this.levelComplete = true
    },
    goNextLevel () {
      if (!this.hasNextLevel) {
        this.finishGame()
        return
      }
      this.level++
      this.startLevel()
    },
    finishGame () {
      this.stopTimer()
      this.showSummary = true
    },
    restartGame () {
      this.showSummary = false
      this.level = 1
      this.maxLevelReached = 0
      this.totalStars = 0
      this.totalMatched = 0
      this.combo = 0
      this.maxCombo = 0
      this.elapsedTime = 0
      this.bankIndex = 0
      this.wordBank = shuffle(this.wordBank)
      this.startTimer()
      this.startLevel()
    },
    startTimer () {
      this.stopTimer()
      this.timer = setInterval(() => { this.elapsedTime++ }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goReturn () {
      if (this.$route.query.source === 'practice' || this.$route.path.includes('practice')) {
        this.$router.push({ path: '/practice?hideTrans=true' })
      } else if (this.$route.query.source) {
        this.$router.push({ path: '/practiceSelectList_display?hideTrans=true', query: this.$route.query })
      } else {
        this.$router.push({ path: '/wordIndex?hideTrans=true' })
      }
    },
    toggleSound () {
      this.soundEnabled = gameSound.toggle()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/word/practice/wordMatch.vue